export class ResetPasswordModel {
    public UserId: string;
    public Username: string;
    public OldPassword: string;
    public Password: string;
    public PasswordConfirmation: string;
    public ResetCode: string;
}
